import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-code-box-line',
      title: 'Website Development',
      description: 'Custom websites, e-commerce platforms, and mobile-responsive design with ongoing maintenance.',
      features: ['Custom Design', 'E-Commerce', 'Mobile-First', 'SEO Optimized']
    },
    {
      icon: 'ri-palette-line',
      title: 'Graphic Design & Branding',
      description: 'Logo design, brand identity, professional packaging labels, and cohesive visual storytelling.',
      features: ['Logo Design', 'Brand Identity', 'Packaging', 'Visual Assets']
    },
    {
      icon: 'ri-search-line',
      title: 'Research & Market Insights',
      description: 'Target audience research, industry trend analysis, and customer behavior insights tailored to your market.',
      features: ['Market Research', 'Trend Analysis', 'Customer Insights', 'Competitive Analysis']
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Data Analysis & Data Science',
      description: 'Data cleaning, visualization, predictive analytics, and decision-support tools for sharper strategy.',
      features: ['Data Cleaning', 'Visualization', 'Predictive Analytics', 'BI Tools']
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Solutions',
      description: 'Business plans, company profiles, financial projections, compliance guidance, and strategic roadmaps.',
      features: ['Business Plans', 'Financial Projections', 'Compliance', 'Strategy']
    },
    {
      icon: 'ri-bank-card-line',
      title: 'FinTech Solutions',
      description: 'Mobile payment platforms, digital wallet systems, and custom financial software integration.',
      features: ['Payment Platforms', 'Digital Wallets', 'API Integration', 'Security']
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="w-full px-4 sm:px-8 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3782df]/10 rounded-full mb-6">
            <div className="w-2 h-2 bg-[#3782df] rounded-full"></div>
            <span className="text-[#3782df] text-sm font-medium">Our Services</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            End-to-End Business Solutions
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            We offer comprehensive support across key areas of modern business development — from digital transformation to strategic growth.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group"
            >
              {/* Icon */}
              <div className="w-14 h-14 bg-[#3782df]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#3782df] transition-colors">
                <i className={`${service.icon} text-2xl text-[#3782df] group-hover:text-white transition-colors`}></i>
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <div className="flex flex-wrap gap-2 mb-4">
                {service.features.map((feature, idx) => (
                  <span 
                    key={idx}
                    className="px-3 py-1 bg-gray-50 text-gray-700 text-xs rounded-full"
                  >
                    {feature}
                  </span>
                ))}
              </div>

              {/* Link */}
              <Link 
                to="/services" 
                className="inline-flex items-center gap-2 text-[#3782df] text-sm font-medium hover:gap-3 transition-all"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link 
            to="/services" 
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#3782df] text-white text-sm font-medium rounded-lg hover:bg-[#2968c4] transition-colors whitespace-nowrap"
          >
            View All Services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}